/******************************************************************
 * Archivo : client/src/mutations/changePassword.js
 * Proyecto: CB30
 * Módulo  : Usuarios
 * Proceso : Cambio de contraseña
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  mutation ChangePassword(
    $currentPassword: String!
    $newPassword: String!
    $confirmPassword: String!
  ) {
    changePassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
      confirmPassword: $confirmPassword
    ) {
      id
      email
      mustChangePassword
    }
  }
`;


// WEBPACK FOOTER //
// ./src/mutations/changePassword.js